import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsOneColumnTextParagraph } from '@om/component-library-react';
import Paragraph from './Paragraph';

const TabsOneColumnTextParagraph = ({
    tabsOneColumnTextParagraph,
    slot
}) => {
    const {
        use_heading_as_h1,
        is_extended,
        section_heading,
        section_caption,
        tab_text_one,
        tab_text_two,
        tab_text_three,
        tab_text_four,
        tab_text_five,
        tab_text_six,
        button_action_type,
        open_tab,
        button_text,
        button_url,
        call_me_back,
        om_one_column_text_paragraph_one,
        om_one_column_text_paragraph_two,
        om_one_column_text_paragraph_three,
        om_one_column_text_paragraph_four,
        om_one_column_text_paragraph_five,
        om_one_column_text_paragraph_six
    } = tabsOneColumnTextParagraph;
    return (
        <OmTabsOneColumnTextParagraph
            slot={slot}
            isExtended={is_extended}
            tabTextOne={tab_text_one}
            tabTextTwo={tab_text_two}
            tabTextThree={tab_text_three}
            tabTextFour={tab_text_four}
            tabTextFive={tab_text_five}
            tabTextSix={tab_text_six}
            buttonText={button_text}
            buttonUrl={button_url}
            buttonActionType={button_action_type}
            callMeBackObject={JSON.stringify(call_me_back)}
            openTab={open_tab}
        >
            {
                use_heading_as_h1 ? (section_heading ? <h1 slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> :'') :
                    (section_heading ? <span slot="section-heading" dangerouslySetInnerHTML={{__html: section_heading}} /> : '')
            }
            {section_caption &&
                <span slot="section-caption" dangerouslySetInnerHTML={{__html: section_caption}} />
            }

            <Paragraph slot="om-one-column-text-paragraph-one" paragraphContent={om_one_column_text_paragraph_one[0]} />
            <Paragraph slot="om-one-column-text-paragraph-two" paragraphContent={om_one_column_text_paragraph_two[0]} />
            <Paragraph slot="om-one-column-text-paragraph-three" paragraphContent={om_one_column_text_paragraph_three[0]} />
            <Paragraph slot="om-one-column-text-paragraph-four" paragraphContent={om_one_column_text_paragraph_four[0]} />
            <Paragraph slot="om-one-column-text-paragraph-five" paragraphContent={om_one_column_text_paragraph_five[0]} />
            <Paragraph slot="om-one-column-text-paragraph-six" paragraphContent={om_one_column_text_paragraph_six[0]} />
        </OmTabsOneColumnTextParagraph>
    )
}
export const pageQuery = graphql`
fragment TabsOneColumnTextParagraph on Contentstack_tabs_one_column_text_paragraph {
    uid
    use_heading_as_h1
    is_extended
    section_heading
    section_caption

    tab_text_one
    tab_text_two
    tab_text_three
    tab_text_four
    tab_text_five
    tab_text_six

    button_action_type
    open_tab
    call_me_back {
          ...CallMeBack
      }
    button_text
    button_url {
        ...Link
    }

    om_one_column_text_paragraph_one {
        ...Paragraph
    }
    om_one_column_text_paragraph_two {
        ...Paragraph
    }
    om_one_column_text_paragraph_three {
        ...Paragraph
    }
    om_one_column_text_paragraph_four {
        ...Paragraph
    }
    om_one_column_text_paragraph_five {
        ...Paragraph
    }
    om_one_column_text_paragraph_six {
        ...Paragraph
    }
  }`;

export default TabsOneColumnTextParagraph;